export enum ConsultationRequestAttachmentType {
  Others = 'others',
  Id = 'id',
  LabResult = 'lab_result',
}
